(ns frontend.ui.component.lp-portal.report.tearsheet.portfolio-locations.view
  (:require
   [frontend.ui.component.chart.view :refer [geomap]]
   [frontend.ui.component.lp-portal.card.view :refer [card]]
   [frontend.ui.component.lp-portal.report.tearsheet.portfolio-locations.style
    :as style]
   [herb.core :refer [<id <class]]
   [frontend.ui.component.lp-portal.text-content.view :as text-content]
   [potpuri.core :as potpuri]
   [common.util :as cu]))

(defn portfolio-locations-card
  [data props]
  [card
   {:title "Locations"
    :id    (<id style/card)}
   [:<>
    [geomap
     (potpuri/deep-merge
      (:figures data)
      {:series (vec
                (concat
                 (->> data
                      :figures
                      :series
                      (cu/remove-by :type "mappoint"))
                 [(->>
                   data
                   :figures
                   :series
                   (cu/filter-by :type "mappoint")
                   (map
                    (fn [s]
                      (assoc
                       s
                       :marker
                       {:symbol
                        "url(https://static.zapflow.com/app/img/lp_portal/icon-map-pin-68.png)"})))
                   (first))]))})]
    [:div
     {:class (<class style/footnote-container)}
     (text-content/optional-footnote data props)]]])
